import { render, staticRenderFns } from "./component_tab.vue?vue&type=template&id=4ba20266&"
import script from "./component_tab.vue?vue&type=script&lang=js&"
export * from "./component_tab.vue?vue&type=script&lang=js&"
import style0 from "./component_tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports